import React from 'react';

import useAxios from 'axios-hooks';
import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import ShowVtrgContent from "../../vitrage/components/show/ShowVtrgContent";
import EditVtrgContent from "../../vitrage/components/edit/EditVtrgContent";

const PageSingle = ({ contact }) => {
  const checkuser = (typeof document.cookie.split(`user_is_allowed=`)[1] != 'undefined') && document.cookie.split(`user_is_allowed=`)[1].split(';')[0] === 'true';
  const VtrgEditMode = checkuser && window.location.pathname.includes('/edit');

  let page_slug = window.location.pathname.includes('/edit') ? window.location.pathname.replace("/edit","").match(/([^\/]*)\/*$/)[1] : window.location.pathname.match(/([^\/]*)\/*$/)[1];
  let page_path = Api.page.replace(':slug', page_slug);

  const [{ data, loading, error }] = useAxios({ url: page_path });
  const page = data ? data.page : {};
  const seo = data ? data.seo : {};
  const vitrage = data ? data.vitrage : {};

  return (
    <div className="pageAbout main-container"> 
      <SeoBlock data={seo} contact={contact} />
      <div className="page-header" style={{ backgroundColor:(page && page.headback ? page.headback : "")}}>
        { loading && <p>Загрузка...</p> }
        { page && page.title && <div className='wrap holder'> <h1 className='h1-title'>{page.title}</h1> </div> }
      </div>
      <div className="page-body">
        { page && page.headbody && <div className='wrap holder'
          dangerouslySetInnerHTML={{ __html:  page.headbody }}
        /> }
      { vitrage && (vitrage.length > 0) && ( VtrgEditMode ? <EditVtrgContent content={vitrage}/> : <ShowVtrgContent content={vitrage}/>) }
      </div>
    </div>
  )
}

export default PageSingle;
